import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button } from 'reactstrap';

import './VehicleLicensePlate.scss';

import commonConstant from '../../common/_commonConstant';
import { trimSpace, randomNumber } from '../../common/_commonFunction';
import { Loading } from '../../components';
import {
  fetchGetLicensePlate,
  fetchGetParkingStatus,
  fetchGetParkingProblems,
  setSearchVehicleType,
} from '../../actions';
import {
  history,
  InputWithIcon,
  isCashier,
  passParamsToPath,
  vehicleLicensePlate,
  validateToShowDash,
  parkingID,
  validateVehiclePlate,
  vehicleTypeIconName,
  IconVehicle,
  vehicleType,
  buildingID,
  vehicleProvince,
  parkingDate,
  historyPayment,
  formatParkingRefNo,
  parkingRefNo,
} from '../../helpers';
import { ParkingStatus, Receipts } from '..';

class VehicleLicensePlate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'search': this.handleKeySearch(props.getVehicleLicensePlate),
      'loading': false,
      'selectVehicleLicensePlate': null,
      'showDetail': null,
      'type': this.handleVehicleType(props.getVehicleLicensePlate),
      'activeReceiptIndex': null,
    };

    if (!this.handleKeySearch(props.getVehicleLicensePlate) || (props.getProfile && !isCashier(props.getProfile))) {
      return history.push(commonConstant.pathCheckRedirect);
    } else {
      this.handleGetParkingStatus(props.getVehicleLicensePlate, this.handleKeySearch(props.getVehicleLicensePlate));
    }
    this.timeout = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getVehicleLicensePlate, getProfile, getParkingStatus, getParkingProblems } = this.props;
    const { search, showDetail } = this.state;

    if (nextProps.getProfile && nextProps.getProfile !== getProfile) {
      if (!isCashier(nextProps.getProfile)) {
        return history.push(commonConstant.pathCheckRedirect);
      }
    } else if (nextProps.getVehicleLicensePlate && nextProps.getVehicleLicensePlate !== getVehicleLicensePlate) {
      if (this.handleGetParkingStatus(nextProps.getVehicleLicensePlate, search) && !showDetail) {
        this.handleSetDataForShowDetail();
      }
      return this.setState({ 'loading': false, 'showDetail': null });
    } else if (nextProps.getParkingStatus && nextProps.getParkingStatus !== getParkingStatus) {
      if (nextProps.getParkingStatus.status === 200) {
        if (!showDetail) {
          this.handleSetDataForShowDetail();
        }
        return this.props.dispatch(fetchGetParkingProblems(parkingID(nextProps.getParkingStatus.data)));
      } else if (nextProps.getParkingStatus.status === 400 && nextProps.getParkingStatus.errorMessage === commonConstant.trowErrorParkingNotFound) {
        return history.push(commonConstant.pathSearchVehicleLicensePlate);
      }
    } else if (nextProps.getParkingProblems && nextProps.getParkingProblems !== getParkingProblems) {
      return this.setState({ 'loading': false });
    }
  }

  componentWillUnmount() {
    this.handleClearTimeOut();
  }

  handleSetTimeOut = () => {
    this.handleClearTimeOut();
    this.timeout = setTimeout(() => history.push(passParamsToPath(commonConstant.pathSearchVehicleLicensePlate, this.props.match.params)), 180000);
  }

  handleClearTimeOut = () => clearTimeout(this.timeout);

  handleTimeOut = () => {
    this.handleClearTimeOut();
    this.handleSetTimeOut();
  }

  handleKeySearch = getVehicleLicensePlate => {
    try {
      return getVehicleLicensePlate.searchVehicle ? getVehicleLicensePlate.searchVehicle : '';
    } catch (err) {
      return '';
    }
  }

  handleVehicleType = getVehicleLicensePlate => {
    try {
      return getVehicleLicensePlate.data.length === 1 && getVehicleLicensePlate.data[0].vehicleType ? getVehicleLicensePlate.data[0].vehicleType : null;
    } catch (err) {
      return null;
    }
  }

  handleGetParkingStatus = (getVehicleLicensePlate, search) => {
    try {
      const { searchVehicleType } = this.props;
      const check = (
        getVehicleLicensePlate.data.length === 1
        && (
          (searchVehicleType.data === 'vehicleLicensePlate' && vehicleLicensePlate(getVehicleLicensePlate.data[0]) === trimSpace(search))
          || (searchVehicleType.data === 'parkingRef' && formatParkingRefNo(parkingRefNo(getVehicleLicensePlate.data[0])) === trimSpace(search))
        ));

      if (check) {
        this.props.dispatch(fetchGetParkingStatus(parkingID(getVehicleLicensePlate.data[0])));
      }

      return true;
    } catch (error) {
      return null;
    }
  }

  handleSetDataForShowDetail = (detailType, activeReceiptIndex) => {
    const { showDetail } = this.state;

    switch (showDetail) {
      case commonConstant.detailParkingStatus:
        return this.setState({ activeReceiptIndex, 'showDetail': detailType });
      case commonConstant.detailReceipts:
        return this.setState({ 'activeReceiptIndex': null, 'showDetail': detailType });
      default:
        return this.setState({ 'activeReceiptIndex': null, 'showDetail': commonConstant.detailParkingStatus });
    }
  }

  handleChange = event => {
    const { getProfile, searchVehicleType } = this.props;

    if (validateVehiclePlate(event.target.value)) {
      if (trimSpace(event.target.value).length >= 3) {
        this.setState({ 'search': event.target.value, 'loading': true, 'showDetail': null });

        return this.props.dispatch(fetchGetLicensePlate(
          buildingID(getProfile),
          searchVehicleType.data === 'vehicleLicensePlate' ? trimSpace(event.target.value) : null,
          commonConstant.parkingStatusIn,
          searchVehicleType.data === 'parkingRef' ? trimSpace(event.target.value) : null,
          true,
        ));
      }
      return this.setState({ 'search': event.target.value });
    }
    return;
  }

  handleClearValue = () => this.setState({ 'search': '' });

  handleResult = () => {
    const { getVehicleLicensePlate, searchVehicleType } = this.props;
    const { showDetail, activeReceiptIndex } = this.state;

    if (showDetail === commonConstant.detailParkingStatus) {
      this.handleClearTimeOut();
      return <ParkingStatus showReceipts={activeIndex => this.handleSetDataForShowDetail(commonConstant.detailReceipts, activeIndex)} />;
    } else if (showDetail === commonConstant.detailReceipts) {
      return <Receipts activeIndex={activeReceiptIndex} showStatus={() => this.handleSetDataForShowDetail(commonConstant.detailParkingStatus)} />;
    } else if (getVehicleLicensePlate.data.length === 0) {
      return (
        <div className="box-not-found">
          <div className="result">ผลการค้นหา</div>
          <div className="result" id="license-plate">
            “{this.handleKeySearch(getVehicleLicensePlate)}”
          </div>
          <img className="not-found" src={commonConstant.notFoundImg} alt="" />
          <div className="text-not-found" id="license-plate-not-found">ไม่พบข้อมูล</div>
        </div>
      );
    } else if (getVehicleLicensePlate.data.length > 1 || (getVehicleLicensePlate.data.length === 1 && vehicleLicensePlate(getVehicleLicensePlate.data[0]) !== this.handleKeySearch(getVehicleLicensePlate))) {
      return (
        <div className="box-layout-car-list">
          <div className="box-car-list">
            <div id="vehicle-license-plate-result-title" className="title">{searchVehicleType.data === 'vehicleLicensePlate' ? 'เลขทะเบียนรถ' : 'รหัสอ้างอิง'}</div>
            {
              getVehicleLicensePlate.data.map((ele, index) => (
                <div
                  id={`license-plate-item-${index}`}
                  className="item"
                  key={randomNumber()}
                  onClick={() => this.handleSelectVehicleLicensePlate(index)}
                >
                  <div className="left">
                    <div id={`vehicle-icon-${index}`} className="vehicle-icon-container">
                      <IconVehicle className="icon" name={vehicleTypeIconName(vehicleType(ele))} />
                    </div>
                    <div className="vehicle-license-plate-container" id={`license-plate-detail-${index}`}>
                      <div id={`license-plate-number-${index}`} className="vehicle-license-plate">
                        {validateToShowDash(searchVehicleType.data === 'parkingRef' ? formatParkingRefNo(parkingRefNo(ele)) : vehicleLicensePlate(ele))}
                      </div>
                      <div id={`vehicle-province-${index}`} className="vehicle-license-plate-province">{vehicleProvince(ele)}</div>
                    </div>
                  </div>
                  <div className="right">
                    <span id={`parking-in-date-${index}`} className="date">{parkingDate(ele)}</span>
                    <span className="icon-arrow-right"/>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      );
    }
  }

  handleSelectVehicleLicensePlate = index => {
    try {
      const { getVehicleLicensePlate, searchVehicleType } = this.props;

      this.setState({
        'loading': true,
        'showDetail': commonConstant.detailParkingStatus,
        'search': searchVehicleType.data === 'parkingRef' ? formatParkingRefNo(parkingRefNo(getVehicleLicensePlate.data[index])) : vehicleLicensePlate(getVehicleLicensePlate.data[index]),
        'type': getVehicleLicensePlate.data[index].vehicleType,
      });

      return this.props.dispatch(fetchGetParkingStatus(parkingID(getVehicleLicensePlate.data[index])));
    } catch (error) {
      return null;
    }
  }

  handleSearchType = typeSearch => {
    const { search } = this.state;
    const { getProfile } = this.props;

    this.props.dispatch(setSearchVehicleType(typeSearch));
    return this.props.dispatch(fetchGetLicensePlate(
      buildingID(getProfile),
      typeSearch === 'vehicleLicensePlate' ? trimSpace(search) : null,
      commonConstant.parkingStatusIn,
      typeSearch === 'parkingRef' ? trimSpace(search) : null,
      true,
    ));
  }

  render() {
    const { search, loading, showDetail } = this.state;
    const { getVehicleLicensePlate, match, getParkingStatus, searchVehicleType } = this.props;

    if (!getVehicleLicensePlate.data) {
      return <Redirect to={passParamsToPath(commonConstant.pathSearchVehicleLicensePlate, match.params)} />;
    } else if (!showDetail) {
      this.handleTimeOut();
    }

    return (
      <div className="VehicleLicensePlate no-sidebar-layout">
        {loading ? <Loading /> : null}
        <div className="group-search-bar">
          {
            showDetail === commonConstant.detailParkingStatus || showDetail === commonConstant.detailReceipts ?
              <span
                onClick={
                  showDetail === commonConstant.detailParkingStatus ?
                    () => history.push(commonConstant.pathSearchVehicleLicensePlate)
                    : () => this.handleSetDataForShowDetail(commonConstant.detailParkingStatus, 0)
                }
                id="btn-back-page"
                className="back"
              >
                <span className="icon fas fa-arrow-left" />
              </span>
              : <span className="dummy-btn-back" />
          }
          <Button
            className="btn-type btn-secondary"
            id="btn-type"
            onClick={() => this.handleSearchType(searchVehicleType.data === 'parkingRef' ? 'vehicleLicensePlate' : 'parkingRef')}
          >
            <span className="icon fa-solid fa-repeat" />
            {
              searchVehicleType.data === 'parkingRef' ?
                <span className="ref" id="type-ref">Ref.</span>
                : <span className="plate" id="type-plate">กก1111</span>
            }
          </Button>
          <InputWithIcon
            id="search-license-plate"
            template="i"
            value={search}
            placeholder={searchVehicleType.data === 'vehicleLicensePlate' ? 'กรอกเลขทะเบียนรถ' : 'กรอกรหัสอ้างอิง'}
            type="clear"
            onChange={this.handleChange}
            handleClearValue={this.handleClearValue}
            maxLength="9"
          />
          {
            showDetail === commonConstant.detailParkingStatus || showDetail === commonConstant.detailReceipts ?
              <span
                className={`btn-receipt${historyPayment(getParkingStatus.data) ? ' active' : ''}`}
                id="btn-show-receipts"
                onClick={historyPayment(getParkingStatus.data) ? () => this.handleSetDataForShowDetail(commonConstant.detailReceipts, 0) : null}
              >
                <span className="icon icon-bill" />
              </span>
              : <span className="dummy-receipt" />
          }
        </div>
        {this.handleResult()}
      </div>
    );
  }
}

VehicleLicensePlate.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'path': PropTypes.string,
    'params': PropTypes.shape({}),
  }),
  'getProfile': PropTypes.shape({}),
  'getVehicleLicensePlate': PropTypes.shape({
    'vehicleLicensePlate': PropTypes.any,
    'data': PropTypes.array,
  }),
  'getParkingStatus': PropTypes.shape({
    'data': PropTypes.shape({}),
    'status': PropTypes.any,
    'errorMessage': PropTypes.any,
  }),
  'getParkingProblems': PropTypes.shape({}),
  'searchVehicleType': PropTypes.shape({
    'data': PropTypes.string,
  }),
};

const mapStateToProps = ({ getVehicleLicensePlate, getProfile, getParkingStatus, getParkingProblems, searchVehicleType }) => ({
  getVehicleLicensePlate,
  'getProfile': getProfile.data,
  getParkingStatus,
  getParkingProblems,
  searchVehicleType,
});

export default connect(mapStateToProps)(VehicleLicensePlate);
